import React, {useState, useEffect} from "react";
import {SideModal, Tabs} from "components";
import {modalTabRoutes} from "../tab-routes";
import {useSelector} from "react-redux";
import {useParams, useHistory} from "react-router-dom";

const Package = () => {
    // Routers
    const {id} = useParams();
    const history = useHistory();

    const serviceProvider = useSelector(state => state.serviceProvider?.users);
    const spOrders = useSelector(state => state.spOrders);

    const [titles, setTitles] = useState();
    const [avgRating, setAvgRating] = useState(0);

    const [popupStatus, setPopupStatus] = useState(true);

    function onClose(){
        setPopupStatus(false);
        history.push(`/service-providers-new/service-providers/`)
    }

    useEffect(() => {
        var avgcount = 0;
        var avgsum = 0;
        spOrders.map((item) => {
            if(item?.getsubsdetails?.get_rating?.sp_rating){
                avgcount++;
                avgsum += item?.getsubsdetails?.get_rating?.sp_rating;
            }
        })
        let avgval = avgsum/avgcount;
        setAvgRating(avgval)
        console.log('avgRating  --> '+avgRating);
        const user = serviceProvider?.find(item => item?.userId == id);

        const titleArr = [
            {key: "Name", value: user?.firstName + " " + user?.lastName},
            {key: "Mobile", value: user?.mobile},
            {key: "Avg Rating", value: avgRating?.toFixed(2)}
        ];
        setTitles(titleArr);
        setPopupStatus(true);
    }, [id,avgRating]);
    return (
        <SideModal
            title="Service Provider ID"
            titles={titles?.length ? [...titles] : []} onClose={onClose} popupStatus={popupStatus}>
            <Tabs routes={modalTabRoutes}/>
        </SideModal>
    );
};

export default Package;
